<template>
  <div class="badge">
    <Tooltip :tooltip-text="badge.label" position="left">
      <img :src="badge.icon" :alt="badge.label" class="badge-image" width="30" height="30" />
    </Tooltip>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import Tooltip from '@/components/Global/Tooltip'

export default defineComponent({
  name: 'BadgeComponent',
  components: {
    Tooltip
  },
  props: {
    badge: {
      type: Object,
      required: true
    }
  }
})
</script>
